import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e5f4410"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewAdditionalServices px-6 py-4 bg-white border" }
const _hoisted_2 = { class: "font-semibold text-xl select-none" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "(не обязательно)", -1))
const _hoisted_4 = {
  key: 0,
  class: "w-full flex items-center justify-center"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "grid grid-cols-4 gap-3 mt-3"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_11 = { class: "text-sm mt-1" }
const _hoisted_12 = { class: "text-sm" }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_15 = { class: "text-sm mt-1" }
const _hoisted_16 = { class: "text-sm" }
const _hoisted_17 = { key: 4 }
const _hoisted_18 = {
  key: 1,
  class: "Checkboxes"
}
const _hoisted_19 = { class: "flex flex-col" }
const _hoisted_20 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_21 = { class: "text-sm mt-1" }
const _hoisted_22 = { class: "text-sm" }
const _hoisted_23 = { class: "flex flex-col" }
const _hoisted_24 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_25 = { class: "text-sm mt-1" }
const _hoisted_26 = { class: "text-sm" }
const _hoisted_27 = { class: "flex items-center justify-end mt-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      (_ctx.isSender)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("Дополнительные услуги при заборе")
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.isReceiver)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode("Дополнительные услуги получателя")
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _hoisted_3,
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_loader, { class: "primary" })
        ]))
      : (_ctx.opened)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.isSetted)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_ctx.state.hasManipulator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Манипулятор"))
                    : _createCommentVNode("", true),
                  (_ctx.state.hasCrane)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Кран"))
                    : _createCommentVNode("", true),
                  (_ctx.state.hasHydraulicTrolley)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createTextVNode(" Рохля "),
                        (_ctx.additionalServices.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("span", _hoisted_11, " Мин. " + _toDisplayString(_ctx.getValue('hydraulic_trolley', 'minValue')) + " часа ", 1),
                              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.getValue('hydraulic_trolley', 'price')) + " тг/час", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.hasLoader)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createTextVNode(" Грузчики "),
                        (_ctx.additionalServices.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createElementVNode("span", _hoisted_15, " Мин. " + _toDisplayString(_ctx.getValue('loader', 'minValue')) + " часа ", 1),
                              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.getValue('loader', 'price')) + " тг/час", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (
                        !_ctx.state.hasManipulator &&
                        !_ctx.state.hasCrane &&
                        !_ctx.state.hasHydraulicTrolley &&
                        !_ctx.state.hasLoader
                    )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Без дополнительных услуг "))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_checkbox, {
                    disabled: _ctx.disabled,
                    label: "Манипулятор",
                    value: _ctx.state.hasManipulator,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.hasManipulator) = $event))
                  }, null, 8, ["disabled", "value"]),
                  _createVNode(_component_checkbox, {
                    disabled: _ctx.disabled,
                    label: "Кран",
                    value: _ctx.state.hasCrane,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.hasCrane) = $event))
                  }, null, 8, ["disabled", "value"]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_checkbox, {
                      disabled: _ctx.disabled,
                      label: "Рохля",
                      value: _ctx.state.hasHydraulicTrolley,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.hasHydraulicTrolley) = $event))
                    }, null, 8, ["disabled", "value"]),
                    (_ctx.additionalServices.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("span", _hoisted_21, " Мин. " + _toDisplayString(_ctx.getValue('hydraulic_trolley', 'minValue')) + " часа ", 1),
                          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.getValue('hydraulic_trolley', 'price')) + " тг/час", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_checkbox, {
                      disabled: _ctx.disabled,
                      label: "Грузчики",
                      value: _ctx.state.hasLoader,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.hasLoader) = $event))
                    }, null, 8, ["disabled", "value"]),
                    (_ctx.additionalServices.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("span", _hoisted_25, " Мин. " + _toDisplayString(_ctx.getValue('loader', 'minValue')) + " часа ", 1),
                          _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.getValue('loader', 'price')) + " тг/час", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])),
            _createElementVNode("div", _hoisted_27, [
              (!_ctx.isSetted)
                ? (_openBlock(), _createBlock(_component_the_button, {
                    key: 0,
                    disabled: _ctx.disabled,
                    class: "primary small text",
                    onClick: _ctx.emitSubmit
                  }, {
                    default: _withCtx(() => [
                      _hoisted_28,
                      _createTextVNode(" Продолжить ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
                : (_openBlock(), _createBlock(_component_the_button, {
                    key: 1,
                    class: "primary small text",
                    disabled: _ctx.disabled,
                    onClick: _ctx.emitUpdate
                  }, {
                    default: _withCtx(() => [
                      _hoisted_29,
                      _createTextVNode(" Редактировать ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}